module.exports = __webpack_public_path__ + "img/gn_04.f2454886.png";